import { createStyles, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() =>
  createStyles({
    plusIcon: {
      marginRight: 9.67,
      height: 20,
      width: 20,
      cursor: 'pointer',
    },
    spSelectGrid: {
      marginTop: 20,
    },
    spSelect: {
      width: '100%',
      height: 44,
      color: 'white',
    },
    autoCompleteGrid: {
      alignSelf: 'center',
      marginTop: 20,
    },
  }),
);
export default useStyles;
